<template>
	<div>
		<el-container>
		  <el-aside width="250px" style="overflow-x: hidden;">
			  <side-bar></side-bar>
		  </el-aside>
		  <el-container>
		    <el-header style="padding:0px;">
				<top-bar></top-bar>
			</el-header>
		    <el-main style="background-color: #f9f9f9;" class="main">
				<router-view/>
			</el-main>
		  </el-container>
		</el-container>
	</div>
</template>

<script>
	import SideBar from "@/components/common/SideBar"
	import TopBar from "@/components/common/TopBar"
	export default {
		name: "Home",
		components:{
			SideBar,
			TopBar
		},
		data() {
			return {

			}
		},
		methods: {

		}
	}
</script>

<style scoped>
.main{
  height:calc(100vh - 60px);
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue